"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChilds = void 0;
const Products_1_1 = __importDefault(require("./Products_1"));
const Products_10_1 = __importDefault(require("./Products_10"));
const Products_11_1 = __importDefault(require("./Products_11"));
const Products_12_1 = __importDefault(require("./Products_12"));
const Products_13_1 = __importDefault(require("./Products_13"));
const Products_14_1 = __importDefault(require("./Products_14"));
const Products_15_1 = __importDefault(require("./Products_15"));
const Products_16_1 = __importDefault(require("./Products_16"));
const Products_17_1 = __importDefault(require("./Products_17"));
const Products_2_1 = __importDefault(require("./Products_2"));
const Products_3_1 = __importDefault(require("./Products_3"));
const Products_4_1 = __importDefault(require("./Products_4"));
const Products_5_1 = __importDefault(require("./Products_5"));
const Products_6_1 = __importDefault(require("./Products_6"));
const Products_7_1 = __importDefault(require("./Products_7"));
const Products_8_1 = __importDefault(require("./Products_8"));
const Products_9_1 = __importDefault(require("./Products_9"));
const products = [
    ...Products_1_1.default,
    ...Products_2_1.default,
    ...Products_3_1.default,
    ...Products_4_1.default,
    ...Products_5_1.default,
    ...Products_6_1.default,
    ...Products_7_1.default,
    ...Products_8_1.default,
    ...Products_9_1.default,
    ...Products_10_1.default,
    ...Products_11_1.default,
    ...Products_12_1.default,
    ...Products_13_1.default,
    ...Products_14_1.default,
    ...Products_15_1.default,
    ...Products_16_1.default,
    ...Products_17_1.default,
];
// Filtramos products que estén habilitados, los policiales si aplica,
// y excluimos cualquier producto cuyo parent no esté habilitado o sin stock.
// Si un producto tiene hijos y todos los hijos están deshabilitados o sin stock, se marca stock = false
const productsWithStockOverride = products.map((p) => {
    const childs = products.filter((prod) => prod.parent === p.id);
    if (childs.length > 0) {
        const anyChildEnabledAndWithStock = childs.some((child) => child.enabled && child.stock !== false);
        if (!anyChildEnabledAndWithStock) {
            return { ...p, stock: false };
        }
    }
    return p;
});
const filteredProducts = productsWithStockOverride.filter((p) => {
    if (!p.enabled) {
        return false;
    }
    // Si tiene parent, comprobar que el parent exista, esté habilitado y tenga stock
    if (p.parent) {
        const parent = productsWithStockOverride.find((prod) => prod.id === p.parent);
        if (!parent || !parent.enabled || parent.stock === false) {
            return false;
        }
    }
    return true;
});
const getChilds = (parentId) => {
    return products.filter((p) => p.parent === parentId);
};
exports.getChilds = getChilds;
exports.default = filteredProducts;
